<template>
    <!-- Einzelnes Feld ///////////////////////////////////////////////////// -->
    <editor-field-frame v-if="!isRepeatable"
                        :label="props.label"
                        :hint="props.hint"
                        :control-id="controlId">
        <template #default="{controlId: id, hintId}">
            <v-text-field v-model="value"
                          v-bind="controlProps"
                          :id="id"
                          :aria-describedby="hintId" />
        </template>
    </editor-field-frame>

    <!-- Wiederholbares Feld: Liste gleichartiger Texte /////////////////////// -->
    <editor-field-frame v-else :label="props.label" :hint="props.hint">
        <v-card class="editor-section-card" variant="outlined">
            <v-card-text>
                <draggable :list="value"
                           :item-key="((item) => value.indexOf(item))"
                           handle=".drag-handle">
                    <template #item="{element, index}">
                        <div class="d-flex align-center mb-3" style="gap: 8px;">
                            <v-icon class="drag-handle" :title="$t('common.actions.move')">mdi-drag-vertical</v-icon>
                            <v-text-field v-model="value[index]" v-bind="controlProps" />
                            <v-btn variant="text" size="small" density="comfortable"
                                   prepend-icon="mdi-close"
                                   @click="removeFromList(element)">{{ $t('common.actions.remove') }}</v-btn>
                        </div>
                    </template>
                </draggable>
            </v-card-text>
            <v-card-actions>
                <v-btn variant="text" color="primary" prepend-icon="mdi-plus"
                       class="normal-case" @click="addToList">{{ $t('editor.fields.list.add_entry') }}</v-btn>
            </v-card-actions>
        </v-card>
    </editor-field-frame>
</template>

<script setup>
import {computed} from "vue";
import draggable from "vuedraggable";
import EditorFieldFrame from "./EditorFieldFrame.vue";
import {
    mandatory_props,
    useEditorField,
    editorControlProps,
    editorControlId,
} from "../../utils/editorConfigFieldHelpers";

const props = defineProps(mandatory_props);
const {value, jsonPath} = useEditorField(props);

/**
 * Ist der gebundene Wert eine Liste? Dann wird das Feld wiederholbar
 * dargestellt. (Bestehendes Verhalten - siehe Sonderfall "Wiederholbarkeit
 * aus dem aktuellen Datenwert" in .editors/EDITOR-BAUKASTEN-UND-GESTALTUNG.md)
 */
const isRepeatable = computed(() => Array.isArray(value.value));

const controlProps = computed(() => editorControlProps(props.vuetify_config));
const controlId = computed(() => editorControlId('text', jsonPath.value));

function addToList() {
    if ( ! Array.isArray(value.value)) return;
    value.value.push("");
}

function removeFromList(text) {
    const index = value.value.indexOf(text);
    if (index > -1) value.value.splice(index, 1);
}
</script>
